import React from 'react';

export type UserContextType = {
  ineligibility_flag: string | null;
  authenticated: boolean;
  eligibility: string;
};

const UserContext = React.createContext<UserContextType>({
  ineligibility_flag: null,
  authenticated: false,
  eligibility: 'unknown',
});

export default UserContext;
